"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _actions = require("../../actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function BriefsHelperMessage(_ref) {
  var page = _ref.page;
  var dispatch = (0, _reactRedux.useDispatch)();
  var visible = (0, _reactRedux.useSelector)(function (state) {
    return state.campaignCreator.helperMessage[page];
  });

  var handleHelperVis = function handleHelperVis() {
    dispatch((0, _actions.setHelperMessageVisibility)(page, true));
  };

  return !visible ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    className: "creative-briefs__helper-message-button",
    onClick: handleHelperVis
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    name: "info circle big",
    className: "creative-briefs__helper-message-icon"
  })) : null;
}

var _default = BriefsHelperMessage;
exports["default"] = _default;